import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {InsertCodeComponent} from "./insert-code/insert-code.component";
import {SingleAuditComponent} from "./audit/single-audit/single-audit.component";
import {EnvelopeAuditComponent} from "./audit/envelope-audit/envelope-audit.component";

const routes: Routes = [
    {path: 'audit', component: InsertCodeComponent},
    {path: 'audit/:code', component: SingleAuditComponent},
    {path: 'envelope/:code', component: EnvelopeAuditComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuditRoutingModule { }
